var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w-50 w-sm-100 m-md-auto mobile pt-2"},[_c('div',{},[_c('VerifyLayoutNew',{attrs:{"auth":this.$route.meta.auth,"hideChangeOption":true}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }